module.exports = __webpack_public_path__ + "img/icon06.ea840812.png";